import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: 320,
  gap: "$md"
});